<template>
    <el-container>
    <div>
        <el-row>
            <el-col style="width:265px;" :class="listClass">
                <singleList
                    ref="leftList"
                    :columnObj="columnLeft"
                    :dataSource="data"
                    :rowKey="props.key"
                    :defauleProps="props"
                    :operateColumn="operateColumn"
                    :hasMutiSelect="true"
                    :lazyloading="false"
                    :hasPage="false"
                    :isPage="isPage"
                    :popFlag="leftPopFlag"
                    :currentPage="currentPage"
                    :nextDisable="nextDisable"
                    :upperShow="upperShow"
                    :upperloading="upperloading"
                    height="400px"
                    :tableLoading="leftLoading"
                    :roleType="roleType"
                    @filterQuery="pageSearchData"
                    @queryData="currentChange"
                    @before="before"
                    @next="next"
                    @rowClick="leftRowClick"
                    @rowDblclick="dblclick"
                    @upperClick="upperClick"
                    @cellMouseEnter="cellMouseEnter"
                    @clearfilterText="clearfilterText"
                ></singleList>
            </el-col>
            <el-col style="width:70px;padding-top:80px;padding-left:20px">
                <el-row>
                    <el-col>
                        <el-button circle size="small" @click.native="addToRight"><i class="el-icon-d-arrow-right"></i></el-button>
                    </el-col>
                    <el-col style="padding-top:10px">
                        <el-button circle size="small" @click.native="addToLeft"><i class="el-icon-d-arrow-left"></i></el-button>
                    </el-col>
                </el-row>
            </el-col>
            <el-col style="width:270px;padding-left:3px" class="listClass">
                <singleList
                    ref="rightList"
                    :rowKey="props.key"
                    :columnObj="columnRight"
                    :dataSource="rightData"
                    :operateColumn="operateColumn"
                    :hasMutiSelect="true"
                    :lazyloading="false"
                    :hasPage="false"
                    :currentPage="currentPage"
                    width="230"
                    height="400px"
                    @filterQuery="onPageFilterQuery"
                    @rowClick="rightRowClick"
                    @rowDblclick="rightDblclick"
                ></singleList>
            </el-col>
        </el-row>
    </div>
    </el-container>
</template>
<script>
import singleList from './singleList.vue';
import api from '../assets/api.js';
export default {
    components: {
        singleList
    },
    props: {
        roleType: {
            type: String,
            default() {
                return '';
            }
        },
        isShowSet: {
            type: Boolean,
            default() {
                return false;
            }
        },
        /**是否允许资源分组 */
        allowResGroup: {
            type: Boolean,
            default() {
                return false;
            }
        },
        /**资源类型 */
        permissionStr: {
            type: String,
            default() {
                return 'org';
            }
        },
        /* 右侧列表数据 key值集合 */
        value: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 数据源 */
        data: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /**是否分页 */
        isPage: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        /* 数据源的字段别名 */
        props: {
            type: Object,
            default: function() {
                return { key: 'key', label: 'label', permissionStr: 'sPermissionStr', resType: 'resType' };
            }
        },
        /* 禁用信息 key值 */
        disabledList: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 初始状态下左侧列表的已勾选项的 key 数组 */
        leftDefaultChecked: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 初始状态下右侧列表的已勾选项的 key 数组 */
        rightDefaultChecked: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 是否启用搜索框 */
        filterable: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        /* 默认显示搜索框占位符 */
        placeholder: {
            type: String,
            default: function() {
                return 'component.PLEASE_INPUT';
            }
        },
        /* 自定义表头文案 */
        titles: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 自定义按钮文案 */
        buttonTexts: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 右侧列表元素的排序策略：若为 original，则保持与数据源相同的顺序；若为 push，则新加入的元素排在最后；
        //     若为 unshift，则新加入的元素排在最前 */
        targetOrder: {
            type: String,
            default: 'original'
        },
        /* 所有权限信息 */
        permissions: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 角色信息 */
        roles: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 权限之一 */
        oneOfPermissions: {
            type: Array,
            default: function() {
                return [];
            }
        },
        // 图片前置路径
        previewImageUrl: {
            type: String,
            default: function() {
                return 'auth';
            }
        },
        /**组织照片名称 */
        orgImgName: {
            type: String,
            default: function() {
                return 'org.png';
            }
        },
        /**区域照片名称 */
        areaImgName: {
            type: String,
            default: function() {
                return 'area.png';
            }
        },
        /**资源照片名称 */
        resImgName: {
            type: String,
            default: function() {
                return 'resDefault.png';
            }
        },
        //查询接口地址
        interfaceName: {
            type: Object,
            default: function() {
                return {
                    query: '',
                    search: ''
                };
            }
        },
        authTrimingMap:{
            type: Object
        }
    },
    data() {
        return {
            leftLoading: false,
            upperloading: false, //返回上一级的loading标识
            orgDbClickFlg: false,
            currentSkin: '',
            /* 是否满足显示权限 */
            permissionsShow: true,
            currentValue: [],
            allData: [],
            rightAllData: [],
            currentPage: 1,
            midData: [],
            nextDisable: false,
            currentKey: '', //当前节点的父节点id
            levelList: ['rootId'], //层级变量 id
            leftChecked: [],
            rightChecked: [],
            rightData: [],
            upperShow: false,
            leftPopFlag: true,
            pageSize: 50,
            listClass: '',
            columnLeft: {
                id: 'sResId',
                label: this.$t('common.CHECK_ALL'),
                prop: 'sResName',
                render: (createElement, params) => {
                    let permissionStr = params.row.sPermissionStr;
                    let imgName = this.resImgName;
                    if (!this.$util.isEmpty(permissionStr)) {
                        imgName = permissionStr + '.png';
                    }
                    let text;
                    if (this.currentSkin == 'skinTwo') {
                        if (permissionStr.match('org') != null) {
                            text = createElement(
                                'div',
                                {
                                    attrs: {
                                        class:'divWordClass',
                                        title: params.row.sResName,
                                    },
                                    props: { type: 'text', size: 'small' },
                                    style: {
                                        padding: '5px 0px 0px 0px',
                                    }
                                },
                                params.row.sResName
                            );
                        } else {
                            text = createElement(
                                'div',
                                {
                                    attrs: {
                                        class:'divWordClass',
                                        title: params.row.sResName,
                                    },
                                    props: { type: 'text', size: 'small' },
                                    style: {
                                        padding: '5px 0px 0px 0px',
                                        color: '#B3B3B3'
                                    }
                                },
                                params.row.sResName
                            );
                        }
                    } else {
                        if (permissionStr.match('org') != null) {
                            text = createElement(
                                'div',
                                {
                                    attrs: {
                                        class:'divWordClass',
                                        title: params.row.sResName,
                                    },
                                    props: { type: 'text', size: 'small' },
                                    style: {
                                        padding: '5px 0px 0px 0px',
                                        color: '#6062BC'
                                    }
                                },
                                params.row.sResName
                            );
                        } else {
                            text = createElement(
                                'div',
                                {
                                    attrs: {
                                        class:'divWordClass',
                                        title: params.row.sResName,
                                    },
                                    props: { type: 'text', size: 'small' },
                                    style: {
                                        padding: '5px 0px 0px 0px',
                                    }
                                },
                                params.row.sResName
                            );
                        }
                    }

                    let img = createElement('img', {
                        attrs: {
                            src: 'skin/' + window.vue.$store.state.skin + '/img/tree/' + imgName,
                            class: 'imgRoleClass'
                        },
                        style: {
                            padding: '3px'
                        }
                        
                    });
                    let res = [img,text];
                    return createElement('div', res);
                }
            },
            columnRight: {
                id: 'sResId',
                label: this.$t('common.CHECK_ALL'),
                prop: 'sResName',
                render: (createElement, params) => {
                    let permissionStr = params.row.sPermissionStr;
                    let imgName = this.resImgName;
                    if (!this.$util.isEmpty(permissionStr)) {
                        imgName = permissionStr + '.png';
                    }
                    let text;
                    let res = [];
                    if (this.currentSkin == 'skinTwo') {
                        if (permissionStr.match('org') != null) {
                            text = createElement(
                                'div',
                                {
                                    attrs: {
                                        class:'divWordClass',
                                        title: params.row.sResName,
                                    },
                                    props: { type: 'text', size: 'small' },
                                    style: {
                                        padding: '5px 0px 0px 0px',
                                    }
                                },
                                params.row.sResName
                            );
                        } else {
                            text = createElement(
                                'div',
                                {
                                    attrs: {
                                        class:'divWordClass',
                                        title: params.row.sResName,
                                    },
                                    props: { type: 'text', size: 'small' },
                                    style: {
                                        padding: '5px 0px 0px 0px',
                                        color: '#B3B3B3'
                                    }
                                },
                                params.row.sResName
                            );
                        }
                    } else {
                        if (permissionStr.match('org') != null) {
                            text = createElement(
                                'div',
                                {
                                    attrs: {
                                        class:'divWordClass',
                                        title: params.row.sResName,
                                    },
                                    props: { type: 'text', size: 'small' },
                                    style: {
                                       padding: '5px 0px 0px 0px',
                                        color: '#6062BC'
                                    }
                                },
                                params.row.sResName
                            );
                        } else {
                            text = createElement(
                                'div',
                                {
                                    attrs: {
                                        class:'divWordClass',
                                        title: params.row.sResName,
                                    },
                                    props: { type: 'text', size: 'small' },
                                    style: {
                                       padding: '5px 0px 0px 0px',
                                    }
                                },
                                params.row.sResName
                            );
                        }
                    }

                    let img = createElement('img', {
                        attrs: {
                            src: 'skin/' + window.vue.$store.state.skin + '/img/tree/' + imgName,
                            class: 'imgRoleClass'
                        },
                        style: {
                            padding: '3px'
                        }
                    });
                    res.push(img);
                    res.push(text);
                    if (this.isShowSet && (this.$util.isArray(this.authTrimingMap[permissionStr]) && this.authTrimingMap[permissionStr].length > 0)) {
                        let set = createElement(
                                'td-button',
                                {
                                    props: {
                                        type: 'text', 
                                        size: 'small',
                                        icon: 'iconfont icongongju'
                                    },
                                    style: {
                                        padding: '8px 0px 0px 0px',
                                        float: 'right'
                                    }, 
                                    on: {
                                        click: () => {
                                            this.btnSet(params.row);
                                        }
                                    }
                                }
                        );
                        res.push(set);
                    }
                    return createElement('div', res);
                }
            }
        };
    },
    watch: {
        value: {
            handler: function(val) {
                if (val.length == 0) {
                    this.currentValue = [];
                } else {
                    this.currentValue = val;
                }
            },
            deep: true
        }
    },
    mounted() {
        /* 初始化禁止操作的数据 */
        for (let i = 0; i < this.data.length; i++) {
            if (JSON.stringify(this.disabledList).indexOf(JSON.stringify(this.data[i][this.props.key])) > 0) {
                this.data[i].disabled = true;
            }
        }
        this.$nextTick(() => {
            //查询右侧数据
            let option = {};
            option.handelPage = false;
            this.queryData(option);
        });
    },
    created() {
        /* 权限数据处理 */
        if (this.permissions.length > 0 || this.oneOfPermissions.length > 0 || this.roles.length > 0) {
            this.permissionsShow = this.dealPermissions(this.permissions, this.roles, this.oneOfPermissions);
        }
        this.currentValue = eval(this.value);
        this.currentSkin = window.vue.$store.state.skin;
    },
    methods: {
        //搜索框查询
        onPageFilterQuery(filterName) {
            if (filterName == null || filterName == '') {
                this.rightData = this.rightAllData;
                return;
            }
            let tempList = this.rightData.filter(function(tempData) {
                return tempData.sResName.toLowerCase().includes(filterName.toLowerCase());
            });
            this.rightData = tempList;
        },
        //检索数据
        pageSearchData(filterName) {
            if (filterName == null || filterName == '') {
                if (!this.orgDbClickFlg) {
                    this.queryDataByType();
                }
                this.orgDbClickFlg = false;
                return;
            }
            this.leftLoading = true;
            if (this.interfaceName == null || this.interfaceName.search == '') {
                this.$log.error("this.interfaceName.search == ''");
                this.nextDisable = false;
                if (this.data == null) {
                    this.leftLoading = false;
                    return;
                }
                let tempList = this.data.filter(function(tempData) {
                    return tempData.sResName.toLowerCase().includes(filterName.toLowerCase());
                });
                this.data = tempList;
                this.leftLoading = false;
                return;
            }

            let queryUrl = this.interfaceName.search;
            
            let param = {
                    name: filterName,
                    needPage: true,
                    currentPage: 1,
                    pageSize: 1000
                };
            let _this = this;
            window.vue.$apiAxios.postRequestBody(queryUrl, JSON.stringify(param), response => {
                if (response.status === _this.$common.login.RESPONSE_STATUS && response.data && response.data.statusCode === _this.$common.requestCode.SUCCESS_INFO_CODE) {
                    let count = response.data.count;
                    if (_this.data == null) {
                        return;
                    }
                    _this.isPage = false;
                    _this.data = response.data.content;;
                } else {
                    _this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    return;
                }
                _this.leftLoading = false;
            });
        },
        queryDoorDevice(filterName) {
            this.leftLoading = true;
            let param = {
                caption: filterName,
                deviceTypeList: [50, 30001, 30004],
                currentPage: 1,
                pageSize: 1000
            };
            api.queryDeviceOrgTreeByName(JSON.stringify(param), response => {
                this.leftLoading = false;
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    return;
                }
                let result = response.data.content;
                let resList = [];
                let resIdList = [];
                result.forEach(res => {
                    //先去重
                    if (resIdList.indexOf(res.sId) == -1) {
                        resIdList.push(res.sId);
                        let tempData = {
                            sResId: res.sId,
                            sResName: res.caption,
                            sPermissionStr: res.sPermissionStr,
                            resParentId: res.deviceType
                        };
                        resList.push(tempData);
                    }
                });
                this.isPage = false;
                this.data = resList;
            });
        },
        //初始化右侧框数据
        initRightListDate(selectedData) {
            this.rightData = selectedData;
            this.rightAllData = this.rightData;

        },
        cellMouseEnter(row) {
            if (row[this.props.permissionStr].match('org') != null) {
                this.listClass = 'listClass';
            } else {
                this.listClass = '';
            }
        },
        //左侧框点击
        leftRowClick(row) {
            this.$refs.leftList.toggleRowSelection(row);
        },
        //右侧框双击
        rightRowClick(row) {
            this.$refs.rightList.toggleRowSelection(row);
        },
        //右侧框双击
        rightDblclick(row) {
            this.$emit("deleteRightData", [row]);
            this.popFlag = false;
            //删除
            this.rightData.forEach((item, index) => {
                if (row[this.props.key] == item[this.props.key]) {
                    this.rightData.splice(index, 1);
                }
            });
            this.rightAllData = this.rightData;
        },
        //返回上一级
        upperClick() {
            let option = {};
            this.queryData(option, true);
        },
        //左侧双击事件
        dblclick(row) {
            //查询
            if (row[this.props.permissionStr].match('org') != null) {
                this.currentPage = 1;
                this.orgDbClickFlg = true;
                this.queryData(row);
            }
        },
        addToLeft() {
            let rightCheckedData = this.$refs.rightList.getSelectAllRows();
            this.$emit("deleteRightData", rightCheckedData);
            rightCheckedData.forEach(data => {
                this.rightData.forEach((item, index) => {
                    if (data[this.props.key] == item[this.props.key]) {
                        this.rightData.splice(index, 1);
                    }
                });
                this.rightAllData = this.rightData;
            });
        },
        addToRight() {
            let leftCheckedData = this.$refs.leftList.getSelectAllRows();
            const itemsToBeMoved = [];
            const key = this.props.key;
            const permissionStr = this.props.permissionStr;
            let allowGroup = true;
            leftCheckedData.forEach(item => {
                if (item[permissionStr].match('org') == null || this.allowResGroup) {
                    itemsToBeMoved.push(item);
                } else {
                    allowGroup = false;
                }
            });
            if (!allowGroup) {
                this.$message({ showClose: true, message: this.$t('role.UN_ALLOW_GROUP'), type: 'warning' });
            }
            //去重
            let repeatedData = [];
            itemsToBeMoved.forEach(element => {
                let flag = false;
                for (let i = 0; i < this.rightData.length; i++) {
                    if (this.rightData[i][key] == element[key]) {
                        flag = true;
                        repeatedData.push(element.sResName);
                        break;
                    }
                }
                if (!flag) {
                    this.rightData.push(element);
                }
            });
            this.rightAllData = this.rightData;
            if (repeatedData.length > 5) {
                repeatedData = repeatedData.slice(0, 5) + '等';
            }
            if (repeatedData.length > 0) {
                this.$message({ showClose: true, message: repeatedData + ' ' + this.$t('role.HAS_EXIST'), type: 'warning' });
            }
            //清空左侧的选择
            this.$refs.leftList.clearSelection();
        },
        btnSet (row) {
            this.$emit('onclickSet', row);
        },
        //获取右侧框的数据
        getAllRightKeys() {
            return this.rightData;
        },
        resetRightKeys() {
            this.rightData = [];
        },
        //上一页
        before() {
            --this.currentPage;
            this.currentChange();
        },
        //下一页
        next() {
            ++this.currentPage;
            this.nextDisable = true;
            this.currentChange();
        },
        currentChange() {
            let option = {
                handelPage: true
            };
            this.allData = this.data;
            this.queryData(option);
        },
        queryDataByType() {
            this.levelList = ['rootId'];
            this.queryData({});
        },
        //查询数据
        queryData(option, isUpper) {
            this.leftLoading = true;
            if (this.interfaceName == null || this.interfaceName.query == '') {
                this.$log.error("this.interfaceName.query == ''");
                this.nextDisable = false;
                return;
            }
            let queryUrl = this.interfaceName.query;
            //返回上一级
            let param = {};
            if (isUpper) {
                if (!this.levelList[this.levelList.length - 1]) {
                    this.nextDisable = false;
                    return;
                }
                param = {
                    pageSize: this.pageSize,
                    pageNum: 1,
                    parentId: this.levelList[this.levelList.length - 2]
                };
                this.currentKey = this.levelList[this.levelList.length - 2];
                this.levelList.pop();
            } else {
                if (!option.handelPage) {
                    this.currentKey = option[this.props.key] == undefined ? 'rootId' : option[this.props.key];
                    if (option[this.props.key] != undefined) {
                        this.levelList.push(this.currentKey);
                    }
                }
                param = {
                    pageSize: this.pageSize,
                    parentId: this.currentKey,
                    pageNum: this.currentPage
                };
            }
            window.vue.$apiAxios.postRequestBody(queryUrl, JSON.stringify(param), response => {
                this.upperloading = false;
                this.leftLoading = false;
                if (response.status === this.$common.login.RESPONSE_STATUS && response.data && response.data.statusCode === this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.data = response.data.content;
                    let count = response.data.count;
                    if (this.data == null) {
                        return;
                    }
                    //穿梭框内容条数判断 小于pageSize数
                    if (count < this.pageSize && !option.handelPage) {
                        this.isPage = false;
                    // 大于或等于 pageSize数进入判断
                    } else if(count === this.pageSize){
                        this.isPage = true;
                        let pageNumTemp = this.currentPage + 1;
                        let paramTemp = {
                            pageSize: this.pageSize,
                            parentId: this.currentKey,
                            pageNum: pageNumTemp
                        };
                        window.vue.$apiAxios.postRequestBody(queryUrl, JSON.stringify(paramTemp), response => {
                            let countTwo = response.data.count;
                            if (countTwo ===  0) {    
                                this.nextDisable = true;
                            } else {
                                this.nextDisable = false;   
                            }
                        })
                    } else {
                        this.isPage = true;
                        if (count < this.pageSize) {
                            this.nextDisable = true;
                        } else {
                            this.nextDisable = false;
                        }
                    }

                    if (this.midData.length > 0) {
                        this.midData.forEach(element => {
                            this.data.push(element);
                        });
                    }
                    if (this.levelList[this.levelList.length - 2]) {
                        this.upperShow = true;
                    } else {
                        this.upperShow = false;
                    }
                    //搜索框数据置空
                    this.$refs.leftList.clearfilterText();
                } else {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('tdTransfer/queryData/response.data.content-------is error', response.data.statusCode);
                    this.nextDisable = false;
                }
            });
        }
    }
};
</script>
<style>
img.imgRoleClass {
    width: 15px;
    height: 15px;
}
.listClass {
    cursor: pointer;
    color: #409eff;
}
div.divWordClass {
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    display: inline-block;
    width: 150px;
}
</style>
